import { render, staticRenderFns } from "./slides.vue?vue&type=template&id=b0e8b60e&"
import script from "./slides.vue?vue&type=script&lang=js&"
export * from "./slides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports